/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Changelog_Alltypes2Inputs */

const id_offerdetail_changelog_alltypes2 = /** @type {(inputs: Offerdetail_Changelog_Alltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua jenis`)
};

const ms_offerdetail_changelog_alltypes2 = /** @type {(inputs: Offerdetail_Changelog_Alltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua jenis`)
};

const da_offerdetail_changelog_alltypes2 = /** @type {(inputs: Offerdetail_Changelog_Alltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle typer`)
};

const de_offerdetail_changelog_alltypes2 = /** @type {(inputs: Offerdetail_Changelog_Alltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Typen`)
};

const en_us2_offerdetail_changelog_alltypes2 = /** @type {(inputs: Offerdetail_Changelog_Alltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All types`)
};

const es_es2_offerdetail_changelog_alltypes2 = /** @type {(inputs: Offerdetail_Changelog_Alltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los tipos`)
};

const es_mx2_offerdetail_changelog_alltypes2 = /** @type {(inputs: Offerdetail_Changelog_Alltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los tipos`)
};

const fil_offerdetail_changelog_alltypes2 = /** @type {(inputs: Offerdetail_Changelog_Alltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lahat ng uri`)
};

const fr_offerdetail_changelog_alltypes2 = /** @type {(inputs: Offerdetail_Changelog_Alltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les types`)
};

const it_offerdetail_changelog_alltypes2 = /** @type {(inputs: Offerdetail_Changelog_Alltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti i tipi`)
};

const hu_offerdetail_changelog_alltypes2 = /** @type {(inputs: Offerdetail_Changelog_Alltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minden típus`)
};

const nl_offerdetail_changelog_alltypes2 = /** @type {(inputs: Offerdetail_Changelog_Alltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle types`)
};

const no_offerdetail_changelog_alltypes2 = /** @type {(inputs: Offerdetail_Changelog_Alltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle typer`)
};

const pl_offerdetail_changelog_alltypes2 = /** @type {(inputs: Offerdetail_Changelog_Alltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie typy`)
};

const pt_br2_offerdetail_changelog_alltypes2 = /** @type {(inputs: Offerdetail_Changelog_Alltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os tipos`)
};

const pt_offerdetail_changelog_alltypes2 = /** @type {(inputs: Offerdetail_Changelog_Alltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os tipos`)
};

const ro_offerdetail_changelog_alltypes2 = /** @type {(inputs: Offerdetail_Changelog_Alltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toate tipurile`)
};

const fi_offerdetail_changelog_alltypes2 = /** @type {(inputs: Offerdetail_Changelog_Alltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaikki tyypit`)
};

const sv_offerdetail_changelog_alltypes2 = /** @type {(inputs: Offerdetail_Changelog_Alltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alla typer`)
};

const vi_offerdetail_changelog_alltypes2 = /** @type {(inputs: Offerdetail_Changelog_Alltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả loại`)
};

const tr_offerdetail_changelog_alltypes2 = /** @type {(inputs: Offerdetail_Changelog_Alltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm türler`)
};

const cs_offerdetail_changelog_alltypes2 = /** @type {(inputs: Offerdetail_Changelog_Alltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Všechny typy`)
};

const bg_offerdetail_changelog_alltypes2 = /** @type {(inputs: Offerdetail_Changelog_Alltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Всички типове`)
};

const ru_offerdetail_changelog_alltypes2 = /** @type {(inputs: Offerdetail_Changelog_Alltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все типы`)
};

const uk_offerdetail_changelog_alltypes2 = /** @type {(inputs: Offerdetail_Changelog_Alltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Усі типи`)
};

const ar_offerdetail_changelog_alltypes2 = /** @type {(inputs: Offerdetail_Changelog_Alltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جميع الأنواع`)
};

const hi_offerdetail_changelog_alltypes2 = /** @type {(inputs: Offerdetail_Changelog_Alltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी प्रकार`)
};

const th_offerdetail_changelog_alltypes2 = /** @type {(inputs: Offerdetail_Changelog_Alltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทุกประเภท`)
};

const ja_offerdetail_changelog_alltypes2 = /** @type {(inputs: Offerdetail_Changelog_Alltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのタイプ`)
};

const zh_cn2_offerdetail_changelog_alltypes2 = /** @type {(inputs: Offerdetail_Changelog_Alltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有类型`)
};

const zh_hant1_offerdetail_changelog_alltypes2 = /** @type {(inputs: Offerdetail_Changelog_Alltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有類型`)
};

const ko_offerdetail_changelog_alltypes2 = /** @type {(inputs: Offerdetail_Changelog_Alltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 유형`)
};

/**
* | output |
* | --- |
* | "All types" |
*
* @param {Offerdetail_Changelog_Alltypes2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_changelog_alltypes2 = /** @type {((inputs?: Offerdetail_Changelog_Alltypes2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Changelog_Alltypes2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_changelog_alltypes2(inputs)
	if (locale === "ms") return ms_offerdetail_changelog_alltypes2(inputs)
	if (locale === "da") return da_offerdetail_changelog_alltypes2(inputs)
	if (locale === "de") return de_offerdetail_changelog_alltypes2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_changelog_alltypes2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_changelog_alltypes2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_changelog_alltypes2(inputs)
	if (locale === "fil") return fil_offerdetail_changelog_alltypes2(inputs)
	if (locale === "fr") return fr_offerdetail_changelog_alltypes2(inputs)
	if (locale === "it") return it_offerdetail_changelog_alltypes2(inputs)
	if (locale === "hu") return hu_offerdetail_changelog_alltypes2(inputs)
	if (locale === "nl") return nl_offerdetail_changelog_alltypes2(inputs)
	if (locale === "no") return no_offerdetail_changelog_alltypes2(inputs)
	if (locale === "pl") return pl_offerdetail_changelog_alltypes2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_changelog_alltypes2(inputs)
	if (locale === "pt") return pt_offerdetail_changelog_alltypes2(inputs)
	if (locale === "ro") return ro_offerdetail_changelog_alltypes2(inputs)
	if (locale === "fi") return fi_offerdetail_changelog_alltypes2(inputs)
	if (locale === "sv") return sv_offerdetail_changelog_alltypes2(inputs)
	if (locale === "vi") return vi_offerdetail_changelog_alltypes2(inputs)
	if (locale === "tr") return tr_offerdetail_changelog_alltypes2(inputs)
	if (locale === "cs") return cs_offerdetail_changelog_alltypes2(inputs)
	if (locale === "bg") return bg_offerdetail_changelog_alltypes2(inputs)
	if (locale === "ru") return ru_offerdetail_changelog_alltypes2(inputs)
	if (locale === "uk") return uk_offerdetail_changelog_alltypes2(inputs)
	if (locale === "ar") return ar_offerdetail_changelog_alltypes2(inputs)
	if (locale === "hi") return hi_offerdetail_changelog_alltypes2(inputs)
	if (locale === "th") return th_offerdetail_changelog_alltypes2(inputs)
	if (locale === "ja") return ja_offerdetail_changelog_alltypes2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_changelog_alltypes2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_changelog_alltypes2(inputs)
	return ko_offerdetail_changelog_alltypes2(inputs)
});
export { offerdetail_changelog_alltypes2 as "offerDetail.changelog.allTypes" }